export default "__VITE_ASSET__QccUp8Cd__"